module.exports = __webpack_public_path__ + "static/img/10.19896529.png";